import { useEffect, useRef, useState } from 'react';
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Box, Flex } from '@chakra-ui/react';
import { resetGetZoomJwtToken, setZoomCallCurrentlyActive, setZoomCallDisplayStatus, setZoomCallInSession } from '../../organizations/actions/zoom-actions';
import { bindActionCreators } from 'redux';
import { openInNewTab } from '../../global/helpers/global-helpers';

const EmbeddedZoomMeetingDisplay = ({
  setZoomCallInSession,
  setZoomCallCurrentlyActive,
  setZoomCallDisplayStatus,
  resetGetZoomJwtToken,
  generatedZoomJwtTokenMetadata
}) => {
  const client = ZoomMtgEmbedded.createClient();

  const zoomLaunchRef = useRef(false);
  const meetingSDKRef = useRef(null);
  const [zoomLocalState, setZoomLocalState] = useState("")

  useEffect(() => {
    if (generatedZoomJwtTokenMetadata) {
      setZoomLocalState({ ...generatedZoomJwtTokenMetadata })
      zoomLaunchRef.current = true
      // TODO: Review: reset the redux to prevent reusing

    }
  }, [generatedZoomJwtTokenMetadata])


  useEffect(() => {
    if (!!zoomLaunchRef.current && zoomLocalState) {
      const { zoomMeetingNumber, zoomJwtSignature, zoomMeetingPassword, zoomDisplayName, zoomClientId, externalMeetingLink, zak } = generatedZoomJwtTokenMetadata || {};

      const joinMeeting = () => {
        client.init({
          zoomAppRoot: document.getElementById('meetingSDKElement'),
          language: 'en-US',
          customize: {
            video: {
              isResizable: false,
              popper: {
                disableDraggable: true
              },
              viewSizes: {
                default: {
                  width: 240,
                  height: 135
                },
                ribbon: {
                  width: 240,
                  height: 135
                }
              }
            },
            toolbar: {
              buttons: [
                ({
                  text: 'Open in new tab',
                  onClick: () => {
                    handleMeetingNewTab(externalMeetingLink)
                  }
                }),
                {
                  text: 'Leave Meeting',
                  onClick: () => {
                    handleLeaveMeetingButton()
                  }
                }
              ]
            }
          }
        })

        client.join({
          appKey: zoomClientId,
          sdkKey: zoomClientId,
          meetingNumber: zoomMeetingNumber,
          signature: zoomJwtSignature,
          userName: zoomDisplayName ? zoomDisplayName : "Team member",
          password: zoomMeetingPassword || "",
          ...(zak && { zak }) // zak number for hosts starting their own meetings
        }).then(() => {
          setZoomCallInSession(true)
          setZoomCallCurrentlyActive(true)
          setZoomCallDisplayStatus('Started')
          resetGetZoomJwtToken() 
        })
      };

      joinMeeting()
      zoomLaunchRef.current = false;
    }
  }, [zoomLocalState, client, generatedZoomJwtTokenMetadata])

  const handleLeaveMeetingButton = () => {
    client.leaveMeeting()
    setZoomCallInSession(false)
    // resetGetZoomJwtToken()
    setZoomCallDisplayStatus(`Left meeting`)
  }

  const handleMeetingNewTab = (meetingLink) => {
    client.leaveMeeting()
    openInNewTab(meetingLink)
  }

  return (
   
    <Box
      position='fixed'
      bottom='16em'
      left='2em'
      // zIndex='10' // Resolves recording prompt and leave meeting ux issues
    >
      <Flex id="meetingSDKElement" ref={meetingSDKRef}>
        {/* Zoom Meeting SDK will render here */}
      </Flex>
    </Box>
  );
};


function mapStateToProps(state) {
  return {
    generatedZoomJwtTokenMetadata: state.generatedZoomJwtToken.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setZoomCallInSession,
      setZoomCallCurrentlyActive,
      setZoomCallDisplayStatus,
      resetGetZoomJwtToken
    },
    dispatch,
  )




export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmbeddedZoomMeetingDisplay));
